import type { SnackBarItemDefault } from 'uikit';

import { createSlice } from '@reduxjs/toolkit';

export interface NotificationsState {
    items: SnackBarItemDefault[];
}

const initialState: NotificationsState = {
    items: [],
};

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        add: (state, action) => {
            state.items.unshift(action.payload);
        },
        remove: (state, action) => {
            state.items = state.items.filter((item) => item.key !== action.payload);
        },
    },
});

export const notificationsSelectors = {
    getItems: (state: NotificationsState) => state.items,
};
